import React from 'react';
import styled from 'styled-components';
import PropTypes, { shape } from 'prop-types';
import I10n from '../features/i10n';
import Device from '../models/Device';
import Select from '../atoms/select';
import ProductInformationCache from '../persistence/description-cache';
import { possible_starter_selections } from '../constants';

const SlottedAdditionalDevicesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  margin-right: 16px;
  min-width: 170px;
`;

class SlottedAdditionalDevicesSettings extends React.Component {

  static propTypes = {
    module: shape(Device),
    isLoading: PropTypes.bool,
    onSelectedSlottedDeviceChange: PropTypes.func,
    starterType: PropTypes.string
  }

  render = () => {
    return (
      <SlottedAdditionalDevicesContainer>
        {this.props.module.slottedAdditionalDevices.map((slottedAdditionalDevice, key) => {
          return (
            <SlottedAdditionalDeviceSetting
              key={key}
              slottedAdditionalDevice={slottedAdditionalDevice}
              onSelectedSlottedDeviceChange={this.props.onSelectedSlottedDeviceChange}
              isLoading={this.props.isLoading}
              starterType={this.props.starterType}
            >

            </SlottedAdditionalDeviceSetting>
          );
        })}
      </SlottedAdditionalDevicesContainer>
    );
  }
}
export default SlottedAdditionalDevicesSettings;

class SlottedAdditionalDeviceSetting extends React.Component {

  static propTypes = {
    slottedAdditionalDevice: PropTypes.object,
    onSelectedSlottedDeviceChange: PropTypes.func,
    isLoading: PropTypes.bool,
    starterType: PropTypes.string
  }

  getLayerTitle = (layer) => {
    let title;
    switch (layer) {
      case -1:
        title = I10n.get('module_setting.sad.base');
        break;
      case 1:
        title = I10n.get('module_setting.sad.terminal_block');
        break;
      default:
        break;
    }

    return title;

  }

  handleChange = (value) => {
    if (value !== this.props.slottedAdditionalDevice.selectedDeviceId) {
      this.props.onSelectedSlottedDeviceChange(this.props.slottedAdditionalDevice.layer, value);
    }
  }

  render = () => {

    return (
      <Container>
        <Select
          title={this.getLayerTitle(this.props.slottedAdditionalDevice.layer)}
          selectedValue={this.props.slottedAdditionalDevice.selectedDeviceId}
          getSelectedValue={() => {
              const device = this.props.slottedAdditionalDevice.selectedDevice.device;
              let result = device.id;
              if (this.props.starterType === possible_starter_selections.PAC && device.productType) {
                if (ProductInformationCache.getDescription(device.id) && ProductInformationCache.getDescription(device.id) !== '...') {
                  return ProductInformationCache.getDescription(device.id);
                }
                result = device.productType;
              }

              if (this.props.starterType === possible_starter_selections.EDGE && device.electricalConnection) {
                result += (` - ${I10n.getOrDefault(`connection_type.${device.electricalConnection}`, device.electricalConnection, 'data')}`);
              }

              if (this.props.starterType === possible_starter_selections.EDGE && device.cover) {
                result += (` - ${I10n.getOrDefault(`connection_type.${device.cover?.replaceAll(' ', '').toLowerCase()}`, device.cover, 'data')}`);
              }

              return result;
            }
          }
          options={this.props.slottedAdditionalDevice.possibleDevices}
          isLoading={this.props.isLoading}
          onValueChange={this.handleChange}
          getValue={(possibleDevice) => possibleDevice.id}
          getOptionText={(possibleDevice) => {
            let result = possibleDevice.id;

            if (this.props.starterType === possible_starter_selections.PAC && possibleDevice.device.productType) {
              if (ProductInformationCache.getDescription(possibleDevice.id) && ProductInformationCache.getDescription(possibleDevice.id) !== '...') {
                return ProductInformationCache.getDescription(possibleDevice.id);
              }
              return possibleDevice.device.productType;
            }

            if (this.props.starterType === possible_starter_selections.EDGE && possibleDevice?.device?.electricalConnection) {
              result += (` - ${I10n.getOrDefault(`connection_type.${possibleDevice?.device?.electricalConnection}`, possibleDevice?.device?.electricalConnection, 'data')}`);
            }

            if (possibleDevice.device.cover) {
              result += (` - ${I10n.getOrDefault(`connection_type.${possibleDevice.device.cover?.replaceAll(' ', '').toLowerCase()}`, possibleDevice.device.cover, 'data')}`);
            }

            return result;
          }}
          getOptionHint={(possibleDevice) => ProductInformationCache.getDescription(possibleDevice.id)}
        >
        </Select>
      </Container>
    );
  }
}
